// <div data-controller="photo-zoom" data-photo-zoom-source="<larger copy>"
//      data-action="mousemove->photo-zoom#move mouseleave->photo-zoom#hide">
// </div>

import { Controller } from "stimulus"

const DEFAULT_FACTOR = 2.5

export default class extends Controller {
  static targets = ["image", "lens"]

  connect() {
    // A laptop with a touch screen answers for the finger on `pointer`, so the
    // mouse is looked up on `any-pointer`.
    this.enabled =
      window.matchMedia("(any-hover: hover) and (any-pointer: fine)").matches
  }

  disconnect() {
    this.hide()
  }

  move(event) {
    if (!this.enabled) return

    const image = this.imageTarget.getBoundingClientRect()
    const x     = event.clientX - image.left
    const y     = event.clientY - image.top

    // The frame is wider than the picture it holds, so the cursor spends part
    // of its time beside it.
    if (x < 0 || y < 0 || x > image.width || y > image.height) return this.hide()

    const lens   = this.lensTarget
    const viewer = this.element.getBoundingClientRect()

    this._show()

    lens.style.left = `${event.clientX - viewer.left}px`
    lens.style.top  = `${event.clientY - viewer.top}px`
    lens.style.backgroundSize =
      `${image.width * this.factor}px ${image.height * this.factor}px`
    lens.style.backgroundPosition =
      `${this._offset(x, image.width, lens.clientWidth)}px ` +
      `${this._offset(y, image.height, lens.clientHeight)}px`
  }

  hide() {
    this.lensTarget.classList.remove("photo-modal__lens--visible")
    this.element.classList.remove("photo-modal__viewer--zooming")
  }

  get factor() {
    return parseFloat(this.data.get("factor")) || DEFAULT_FACTOR
  }

  // Private methods

  _show() {
    if (!this.loaded) {
      this.loaded = true
      // The picture on screen is in cache, so the lens fills on the first move.
      this._paint(this.imageTarget.currentSrc || this.imageTarget.src)
      this._loadSource()
    }

    this.lensTarget.classList.add("photo-modal__lens--visible")
    this.element.classList.add("photo-modal__viewer--zooming")
  }

  _loadSource() {
    const source = this.data.get("source")
    if (!source) return

    const loader  = new Image()
    loader.onload = () => this._paint(source)
    loader.src    = source
  }

  _paint(source) {
    if (!source) return

    this.lensTarget.style.backgroundImage = `url("${source}")`
  }

  // Pointing near an edge slides the magnified copy back, rather than opening
  // a blank crescent beside it.
  _offset(cursor, size, lensSize) {
    const magnified = size * this.factor
    if (magnified <= lensSize) return (lensSize - magnified) / 2

    return Math.min(
      0,
      Math.max(lensSize - magnified, lensSize / 2 - cursor * this.factor)
    )
  }
}
